<style lang="sass">
@import ~bi/utilities
@import ~bi/brand/variables
@import ../../assets/sass/m3_variables
@import sass/menu
</style>

<template>
    <div>
        <Header class="g_menu">
            <div class="g_restrict">
                <div class="g_cell">
                    <button v-if="$breakpoint.isS" class="g_burger" :class="{ g_opened: isOpen }" @click="openClose">
                        <span v-html="data.open" class="g_open"></span>
                        <span v-html="data.close" class="g_close"></span>
                        <span></span>
                    </button>
                    <div
                        class="g_smallm3"
                        :class="{ g_appear: appear }"
                        v-img-src="{ folder: 'logos', name: 'small-m3', ext: 'png', suffix: false }" />
                    <nav>
                        <ul>
                            <li v-if="$breakpoint.isS">
                                <div>
                                    <div
                                        class="g_logo"
                                        v-img-src="{ folder: 'logos', name: 'logo-m3', ext: 'png', suffix: false }" />
                                </div>
                            </li>
                            <li
                                v-for="(item, index) in data.list"
                                :key="index">
                                <div>
                                    <Cta
                                        v-if="item.link && !item.anchor"
                                        type="text"
                                        class="g_txt_S"
                                        :link="item.link"
                                        target="_self"
                                        :content="item.name" />
                                    <Cta
                                        v-if="pageIs('index') && item.anchor"
                                        type="button"
                                        class="g_txt_S"
                                        @click="openClose"
                                        :scrollTo="`#${item.anchor},60`"
                                        :content="item.name" />
                                    <Cta
                                        v-if="!pageIs('index') && item.anchor"
                                        type="text"
                                        class="g_txt_S"
                                        :link="item.link + '?' + item.anchor"
                                        target="_self"
                                        :content="item.name" />
                                    <Cta
                                        v-if="item.popin"
                                        type="button"
                                        class="g_txt_S"
                                        @click="openPopin()"
                                        :content="item.name" />
                                </div>
                            </li>
                            <li v-if="$breakpoint.isS">
                                <div>
                                    <Cta
                                        type="text"
                                        class="g_txt_S"
                                        :link="data.courriel.link"
                                        target="_self"
                                        :content="data.contact" />
                                    <Cta
                                        v-if="data.phone.link"
                                        type="text"
                                        class="g_btn g_btnBuy g_phone"
                                        :link="data.phone.link"
                                        target="_self"
                                        fontIcon="fn_phone"
                                        :content="data.phone.cta" />
                                    <Cta
                                        v-if="data.courriel.link"
                                        type="text"
                                        class="g_btn g_btnBuy g_contact"
                                        :link="data.courriel.link"
                                        target="_self"
                                        fontIcon="fn_email"
                                        :content="data.courriel.cta" />
                                </div>
                            </li>
                        </ul>
                    </nav>
                    <!-- Bouton contact -->
                    <!-- <Cta
                        v-if="!$breakpoint.isS"
                        type="text"
                        class="g_btn g_btnBuy g_smallBtn"
                        :link="data.courriel.link"
                        target="_self"
                        fontIcon="fn_email"
                        :content="data.courriel.cta" />
                    <Cta
                        v-else
                        type="text"
                        class="g_btn g_btnBuy g_smallBtn"
                        :link="data.phone.link"
                        target="_self"
                        fontIcon="fn_phone"
                        :content="data.phone.cta" /> -->
                    <!-- Bouton devis -->
                    <Cta
                        type="button"
                        class="g_btn g_btnDevis g_smallBtn"
                        fontIcon="fn_email"
                        @click="openPopin()"
                        :content="data.devis.cta" />
                </div>
            </div>
        </Header>
        <div ref="watcher" class="g_watcher" tabindex="-1" aria-hidden="true"/>
        <Popin
            ref="popin"
            class="g_popinDevis"
            v-model="popinOpened"
            :closeLabel="config.popin.close"
            @focusBack="$emit('focusBack')">
            <slot name="main">
                <div class="g_popinContainer">
                    <div class="g_text">
                        <Paragraph :content="data.devis.title" size="XL" />
                        <Cta
                            v-if="config.links.int.link"
                            type="text"
                            class="g_btn g_btnBuy g_btnDevis"
                            :link="config.links.int.link"
                            target="_self"
                            fontIcon="fn_download"
                            :content="config.links.int.cta" />
                        <Paragraph class="g_or" v-if="config.links.rooms.link" :content="data.devis.or" size="L" />
                        <Cta
                            v-if="config.links.rooms.link"
                            type="text"
                            class="g_btn g_btnBuy g_btnDevis"
                            :link="config.links.rooms.link"
                            target="_self"
                            fontIcon="fn_download"
                            :content="config.links.rooms.cta" />
                        <Paragraph class="g_or" v-if="config.links.ext.link" :content="data.devis.or" size="L" />
                        <Cta
                            v-if="config.links.ext.link"
                            type="text"
                            class="g_btn g_btnBuy g_btnDevis"
                            :link="config.links.ext.link"
                            fontIcon="fn_download"
                            target="_self"
                            :content="config.links.ext.cta" />
                        <Paragraph :content="data.devis.subtitle" size="L" />
                        <Paragraph class="g_orContact" :content="data.devis.contact" size="L" />
                        <Cta
                            v-if="footer.fixe.link"
                            type="text"
                            class="g_link g_fixe"
                            :link="footer.fixe.link"
                            target="_self"
                            :content="footer.fixe.cta" />
                        <Cta
                            v-if="footer.mobile.link"
                            type="text"
                            class="g_link g_mobile"
                            :link="footer.mobile.link"
                            target="_self"
                            :content="footer.mobile.cta" />
                        <div>
                            <Cta
                                v-if="data.courriel.link"
                                type="text"
                                class="g_btn g_btnBuy g_contact"
                                :link="data.courriel.link"
                                target="_self"
                                fontIcon="fn_email"
                                :content="data.courriel.cta" />
                        </div>
                    </div>
                </div>
            </slot>
        </Popin>
    </div>
</template>

<script>
import IntersectionObserverManager from 'library/src/utils/IntersectionObserverManager'

export default {
    name: 'Menu',
    props: {
        data: {
            type: Object,
            required: true
        },
        footer: {
            type: Object,
            required: true
        },
        config: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            appear: false,
            isOpen: false,
            popinOpened: false
        }
    },
    watch: {
        '$json' () {
            this.load()
        }
    },
    mounted () {
        this.load()
        window.addEventListener('resize', this.load, { passive: true })
    },
    methods: {
        openClose () {
            this.isOpen = !this.isOpen
        },
        openPopin () {
            this.popinOpened = !this.popinOpened
        },
        pageIs (page) {
            return this.$landing.project === page
        },
        load () {
            if (this.pageIs('index')) {
                const iom = new IntersectionObserverManager({
                    isLandscape: {
                        above: [0],
                        rootMargin: '0px 0%'
                    },
                    isPortrait: {
                        above: [0],
                        rootMargin: '0px 0%'
                    }
                })
                if (iom.hasIntersectionObserver()) {
                    iom.addItem({
                        element: this.$refs.watcher,
                        onViewportEnter: () => {
                            this.appear = false
                        },
                        onViewportOut: () => {
                            this.appear = true
                        }
                    })
                } else {
                    this.appear = true
                }
            } else {
                this.appear = true
            }
        }
    }
}
</script>
